import { z } from "zod";
export const Citizenship = z
    .string()
    .length(2, "Country codes must be 2 letters")
    .nullable()
    .describe("The citizenship of the client");
//# sourceMappingURL=citizenship.js.map